export const API_HOST = import.meta.env.VITE_API_HOST;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const TOASTS_ENABLED = import.meta.env.VITE_TOASTS_ENABLED !== 'false';
